<template>
  <div class="qr">
    <div class="qrcode" ref="qrCodeUrl"></div>
    <!-- <div class="img-div">
      <img class="header-img" :src="avatarName" alt="">
    </div> -->
  </div>
</template>
<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      // staffId:''
    };
  },
  props:{
    staffId: {
      type: Number,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return null
      }
    },
    avatarName:{
      type:String,
      default: function () {
        return null
      }
    }
  },
  watch:{
    staffId:{ //监听的对象
        deep:true, //深度监听设置为 true
        handler:function(){
            if(this.staffId){
                this.creatQrCode()
            }
        }
    }
    },
  methods: {
    // getStaffs(){
    //   let id=localStorage.getItem("userid")
    //   this.$http.get(this.$api.getStaffs,{userId:id}).then(res=>{
    //     let staffId=res.data.id
    //     this.creatQrCode(staffId);
    //   })
    // },
    // 生成二维码页面
    creatQrCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        // text: this.commonUrl.LONE_URL+'cDetails?isInfo=1&flg=1&id='+this.staffId, //生成二维码的内容（链接或者其他）
        text: process.env.VUE_APP_LOAN_URL+'cDetails?isInfo=1&flg=1&id='+this.staffId, //生成二维码的内容（链接或者其他）
        width: 50, //生成的二维码的宽度
        height: 50, //生成的二维码的高度
        colorDark : "#000000", // 生成的二维码的深色部分
        colorLight : "#ffffff", //生成二维码的浅色部分
        correctLevel : QRCode.CorrectLevel.L,//纠错等级
        background : "#ee0a24",//背景颜色
        foreground : "#cb0aee",//前景颜色
        // src : require('../../assets/logo.png')  //二维码中间的图片
      });
    },

  },
  mounted() {
    if(this.staffId){
        this.creatQrCode()
    }
    // this.getStaffs()
  },
};
</script>
<style lang="less" >
// .d-qr{
//   position: relative;
//   .d-header-img{
//    width: 0.15rem;
//   height: 0.15rem;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// }
// .d-img-div{
//   width: 0.16rem;
//   height: 0.16rem;
//   background: #fff;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   padding: 2px;
// }
// }

// .d-qrcode {
//   background: #fff;
//   padding: 0.05rem;
//   img {
//     width: 0.85rem;
//     height: 0.85rem;
//     background-color: #fff; //设置白色背景色
//     // padding: 2px; // 利用padding的特性，挤出白边
//     box-sizing: border-box;
//     // border-radius: 50%;
//   }
// }

</style>
